module.exports = __webpack_public_path__ + "static/img/s4.a9b62b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market102/s4.png
// module id = Tt32
// module chunks = 1